import Select from 'react-select'

type Props = {
  filters: any
  setFilters: any
  zones?: any[]
  towels?: any[]
}

export const TowelsFilters = ({filters, setFilters, zones}: Props) => {
  return (
    <div className='card mb-5'>
      <div className='card-body d-flex gap-3 flex-wrap'>
        {/* codigo */}
        <div style={{minWidth: 220}}>
          <input
            type='text'
            className='form-control'
            placeholder='Buscar por código...'
            value={filters.codigo || ''}
            onChange={(e) =>
              setFilters({
                ...filters,
                codigo: e.target.value,
              })
            }
          />
        </div>

        {/* estado */}
        <Select
          placeholder='Estado'
          options={[
            {value: 'disponible', label: 'Disponible'},
            {value: 'en_uso', label: 'En uso'},
            {value: 'lavanderia', label: 'Lavandería'},
            {value: 'merma', label: 'Merma'},
          ]}
          onChange={(e) =>
            setFilters({
              ...filters,
              status: e?.value || '',
            })
          }
          isClearable
        />

        {/* tipo */}
        <Select
          placeholder='Tipo'
          options={[
            {value: 'De Mano', label: 'De Mano'},
            {value: 'De Cuerpo', label: 'De Cuerpo'},
            {value: 'De Rayas', label: 'De Rayas'},
          ]}
          onChange={(e) =>
            setFilters({
              ...filters,
              tipo: e?.value || '',
            })
          }
          isClearable
        />

        {/* zona */}
        <Select
          placeholder='Zona'
          options={(zones || []).map((zone) => ({
            value: zone.id,
            label: zone.nombre,
          }))}
          onChange={(e) =>
            setFilters({
              ...filters,
              zona: e?.value || '',
            })
          }
          isClearable
        />
      </div>
    </div>
  )
}
